import { ReactNode, useState, useCallback } from "react";
import { DriverContext } from "./context";

interface DriverProviderProps {
  children: ReactNode;
}

export function DriverProvider({ children }: DriverProviderProps) {
  const [driverInstance, setDriverInstance] = useState<any>(null);
  const [isTourOpen, setIsTourOpen] = useState(false);

  const startTour = useCallback(() => {
    if (driverInstance) {
      driverInstance.drive();
      setIsTourOpen(true);
    }
  }, [driverInstance]);

  const stopTour = useCallback(() => {
    if (driverInstance) {
      driverInstance.destroy();
      setIsTourOpen(false);
    }
  }, [driverInstance]);

  const nextStep = useCallback(() => {
    if (driverInstance && isTourOpen) {
      driverInstance.moveNext();
    }
  }, [driverInstance, isTourOpen]);

  const previousStep = useCallback(() => {
    if (driverInstance && isTourOpen) {
      driverInstance.movePrevious();
    }
  }, [driverInstance, isTourOpen]);

  return (
    <DriverContext.Provider
      value={{
        driverInstance,
        setDriverInstance,
        isTourOpen,
        setIsTourOpen,
        startTour,
        stopTour,
        nextStep,
        previousStep,
      }}
    >
      {children}
    </DriverContext.Provider>
  );
}
